var trans = {
	'test': 'foo en',
	'ENTRAR_UC': 'ENTER',
	'ATUALIZAR': 'Update',
	'SAIR': 'Exit',
	'OBSERVACOES': 'Observations',
	'DEBITAR': 'Debit',
	'CANCELAR': 'Cancel',
	'ROUPA': 'Clothing',
	'RESUMO': 'Summary',
	'AREA': 'Area',
	'COLABORADOR_A': 'Collaborator',
	'QTD_QUARTOS': 'No. of Rooms',
	'TEMPO_TOTAL_MIN': 'Total Time (min)',
	'ESTADO': 'State',
	'N_PESSOAS': 'No. of People',
	'CAMAS_EXTRA': 'Extra Beds',
	'NAO_INCOMODAR': 'Do Not Disturb',
	'LIMPEZA_PRIORITARIA': 'Priority Cleaning',
	'ESTADO_RESERVA': 'Reservation State',
	'MUDAR_LENCOIS': 'Change Sheets',
	'NAO': 'No',
	'SIM': 'Yes',
	'BERCOS': 'Cribs',
	'NAO_LIMPAR': 'Do Not Clean',
	'TEMPO_MIN': 'Time (min)',
	'INICIO_UC': 'START',
	'FIM_UC': 'END',
	'LIMPO_UC': 'CLEAN',
	'ROUPA_UC': 'CLOTHING',
	'INSPECAO_UC': 'INSPECTION',
	'PRECISA_DE_LIGACAO_A_INTERNET': 'Internet connection is needed to access this feature.',
	'RESERVAS_NO_POST': 'No Post reservations do not allow this operation.',
	'OCORREU_UM_PROBLEMA_AO_TENTAR': 'An error occurred while trying to send the message.',
	'LIMPO_C_ENTRADA': 'Clean with Entry',
	'LIMPO': 'Clean',
	'SAIDA_C_ENTRADA': 'Exit with Entry',
	'SUJO_C_ENTRADA': 'Dirty with Entry',
	'SAIDA': 'Exit',
	'OCUPADO': 'Occupied',
	'SUJO': 'Dirty',
	'SUJA': 'Dirty',
	'EM_FALTA': 'Missing',
	'TOTAL': 'Total',
	'ARTIGO': 'Item',
	'QTD': 'Qty.',
	'CONSUMO': 'Consumption',
	'QUEBRA': 'Breakage',
	'EXISTEM_ALTERACOES_NOS_CONSUMOS': 'There are changes in room consumption.',
	'EXISTEM_ALTERACOES_NAS_QUEBRAS': 'There are changes in the breaks in the room.',
	'PRETENDE_AVANCAR': 'Do you want to proceed?',
	'ESTADO_DO_QUARTO': 'Room State',
	'AVALIACAO': 'Evaluation',
	'AVALIACAO_GERAL': 'Overall Evaluation',
	'AVALIACAO_MANUTENCAO': 'Maintenance',
	'AVALIACAO_LIMPEZA': 'Cleaning',
	'INSPECIONADO': 'Inspected',
	'O_CAMPO_AVALIACAO_E_OBRIGATORIO': 'The General Evaluation field is mandatory.',
	'O_CAMPO_MANUTENCAO_E_OBRIGATORIO': 'The Maintenance field is required.',
	'O_CAMPO_LIMPEZA_E_OBRIGATORIO': 'The Cleaning field is required.',
	'QUANTIDADE': 'Quantity',
	'NAO_EXISTE_ROUPA_ATRIBUIDA_PARA': 'There is no clothing assigned for this area.',
	'BLOCO': 'Block',
	'PISO': 'Floor',
	'N_QUARTO': 'Room No.',
	'ESTADO_LIMPEZA': 'Cleaning State',
	'QUARTOS': 'Rooms',
	'AVISO': 'Warning',
	'ERRO': 'Error',
	'PESQUISA' : 'Search',
	'REGIME': 'Regime',
	'CONFIRMAR': 'Confirm',
	'AVANCAR': 'Advance',
	'INSPECTION_NOT_SAVED_NO_INTERNET': 'Inspection not save. No internet.',
	'BREAKING_NOT_SAVED_NO_INTERNET': 'Minibar debit not saved. No internet.',
	'PESQUISAR': 'Search',
	'FECHAR': 'Close',
	'RESET': 'Reset',
	'RESERVA': 'Reservation',
	'ADULTOS': 'Adults',
	'CRIANCAS_4_12': 'Children 4-12',
	'CRIANCAS_0_3': 'Children 0-3',
	'NAO_NO_SHOW': 'No reservations were found with the status "No Show".',
	'REPORT': 'Report',
	'NO_SHOW': 'No Show',
	'TIPOLOGIA': 'Typology',
	'ESTADO_QUARTO': 'Room Status',
	'HORA_INSPECAO_GOVERNANTA': 'Housekeeper Inspection Time',
	'HORA_INSPECAO_DIRECAO': 'Management Inspection Time', 
	'INSPECAO_GOVERNANTA': 'Housekeeper Inspection',
	'INSPECAO_DIRECAO': 'Management Inspection',
	'O_CAMPO_OBSERVACAO_E_OBRIGATORIO': 'The \'Room Observations\' field is required for the room status \'Maintenance/Blocked\'',
	'OBSERVACOES_QUARTO': 'Room Observations',
	'OBSERVACOES_INSPECAO': 'Inspection Observations',
}
module.exports = trans;